import React from 'react';
import styled from 'styled-components';
import { IPartitionValueFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import PartitionValuesDisplay from '../../../Builder/Partition/PartitionValuesDisplay';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { theme } from '../../../../styles/theme';

interface IProps {
  partitionValue: IPartitionValueFieldsFragment;
}

const Container = styled(BuilderInfoUI.HorizontalRow)`
  display: flex;
  align-items: center;
  min-height: 26px;
  padding-right: 8px;
  border-bottom: 1px solid ${theme.colors.border};
`;

const PartitionValue = styled.div`
  font-weight: 500;
  color: ${theme.colors.mainBlue};
`;

export default ({ partitionValue }: IProps) => {
  return (
    <Container>
      <BuilderInfoUI.PlainInfo>
        <BuilderInfoUI.InfoLabel>Converted within</BuilderInfoUI.InfoLabel>
        <PartitionValue>
          <PartitionValuesDisplay partitionValues={[partitionValue]} />
        </PartitionValue>
      </BuilderInfoUI.PlainInfo>
    </Container>
  );
};
